import {call, put, select} from "redux-saga/effects";
import api from "../../services/api";
import apiChat from "../../services/apiChat";
import {Creators as UsuariosActions} from "../ducks/usuarios";
import {Creators as ModalActions} from "../ducks/modal";
import {Creators as ModalSettingsActions} from "../ducks/modalSettings";
import {Creators as ModalLocalWorkingActions} from "../ducks/modalLocalWorking";
import {Creators as ModalPhotoActions} from "../ducks/modalPhoto";
import {Creators as AlertActions} from "../ducks/alert";
import {Creators as ErrorActions} from "../ducks/error";
import {Creators as SuccessActions} from "../ducks/success";
import {Creators as LoadingActions} from "../ducks/loading";
import {Creators as PageActions} from "../ducks/pages";
import moment from "moment";
import AvatarImg from "../../assets/avatar.png";
import React from "react";

export function* getListUsuarios() {
  try {
    yield put(LoadingActions.setLoading());
    const {page, rowsPerPage, filter} = yield select(state => state.usuarios);
    const {data} = yield call(
      api.post,
      `/users/filter?page=${page + 1}&&per_page=${rowsPerPage}`,
      filter
    );
    const {data: usuarios, total} = data;
    let usuariosPayload = [];
    usuariosPayload = usuarios.map(usuario => ({
      id: usuario.id,
      avatar: usuario.avatar
        ? `<div class="avatar-listagem"><img src="${usuario.avatar}" /></div>`
        : `<div class="avatar-listagem"><img src="${AvatarImg}" /></div>`,
      name: usuario.name
        ? !usuario.actived
          ? `<strike class="inactived">${usuario.name}</strike>`
          : (usuario.login_blocked)
            ? "<span style='color: #d12120;'>" + usuario.name + " <i class='fas fa-lock'></i></span>"
            : usuario.name
        : "",
      cpf_cnpj: usuario.cpf_cnpj ? usuario.cpf_cnpj : "",
      login: usuario.login ? usuario.login : "",
      groups_access:
        usuario.groups_access && usuario.groups_access.length > 0
          ? usuario.groups_access[0].name
          : "",
      type: usuario.type ? usuario.type.name : "",
      address:
        usuario.addresses && usuario.addresses.length > 0
          ? `${
            usuario.addresses[0].city ? usuario.addresses[0].city + "/" : ""
          }${usuario.addresses[0].state ? usuario.addresses[0].state : ""}`
          : "",
      pesquisador: usuario.pesquisador ? 1 : 0,
      login_blocked: usuario.login_blocked,
      actions: `<div class='user-acess-cell'>
      <div>
       ${
        usuario.last_login
          ? "<span class='user-acess'><span class='tag-child'><span class='tag-row'>Último Acesso</span></span><i class='fas fa-unlock'></i> " +
          moment(usuario.last_login).format("DD/MM/YYYY HH:mm:ss") +
          "</span>"
          : ""
      }
      </div>
      <div class="pt-1">
      ${
        usuario.last_action
          ? "<span class='user-acess'><span class='tag-child'><span class='tag-row'>Última Ação</span></span><i class='fas fa-history'></i> " +
          moment(usuario.last_action).format("DD/MM/YYYY HH:mm:ss") +
          "</span>"
          : ""
      }
      </div>
      </div>`
    }));
    const name = "Usuários";
    const path = "usuarios";
    yield put(PageActions.setPage(name, path));
    yield put(UsuariosActions.getListUsuariosSuccess(usuariosPayload, total));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getUsuarios({payload}) {
  try {
    yield put(LoadingActions.setLoading());
    const {data} = yield call(api.get, `/users/${payload.id}`);
    data.cpf_cnpj = data.cpf_cnpj ? data.cpf_cnpj : "";
    data.birthday = data.birthday
      ? moment(data.birthday).format("DD/MM/YYYY")
      : "";
    data.marital_status = data.marital_status
      ? data.marital_status.toUpperCase()
      : "";
    data.gender = data.gender ? data.gender.toUpperCase() : "";
    data.rg = data.rg ? data.rg : "";
    data.rg_date = data.rg_date
      ? moment(data.rg_date).format("DD/MM/YYYY")
      : "";
    data.rg_org = data.rg_org ? data.rg_org : "";
    data.rg_uf = data.rg_uf ? data.rg_uf : "";
    data.father_name = data.father_name ? data.father_name : "";
    data.mother_name = data.mother_name ? data.mother_name : "";
    data.relation_name = data.relation_name ? data.relation_name : "";
    data.email = data.email ? data.email : "";
    data.email2 = data.email2 ? data.email2 : "";
    data.email3 = data.email3 ? data.email3 : "";
    data.admission_date = data.admission_date
      ? moment(data.admission_date).format("DD/MM/YYYY")
      : "";
    data.salary = data.salary ? data.salary : "";
    data.demission_date = data.demission_date
      ? moment(data.demission_date).format("DD/MM/YYYY")
      : "";
    data.obs = data.obs ? data.obs : "";
    data.contacts =
      data.contacts && data.contacts.length > 0
        ? data.contacts.map(contact => {
          contact.type = contact.type ? contact.type.toUpperCase() : "";
          contact.notes = contact.notes ? contact.notes.toUpperCase() : "";
          contact.type_reference = contact.type_reference
            ? contact.type_reference.toUpperCase()
            : "";
          return contact;
        })
        : [];
    data.bank_id = data.bank_id ? data.bank_id : "";
    data.agency = data.agency ? data.agency : "";
    data.account_number = data.account_number ? data.account_number : "";
    data.account_owner_name = data.account_owner_name
      ? data.account_owner_name
      : "";
    data.account_owner_cpf = data.account_owner_cpf
      ? data.account_owner_cpf
      : "";
    yield put(UsuariosActions.getUsuariosSuccess(data));
    const {action} = yield select(state => state.usuariosStores);
    if (action === "EDIT" || action === "DETAIL") {
      yield put(ModalActions.open());
    } else if (action === "SETTINGS") {
      yield put(ModalSettingsActions.openSettings());
    } else if (action === "PHOTO") {
      yield put(ModalPhotoActions.openPhotoModal());
    } else {
      const title = "Aviso de exclusão";
      const body = `O cadastro "${data.name}" será excluido do sistema.`;
      yield put(AlertActions.openAlert(title, body));
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* editUsuarios({payload}) {
  try {
    yield put(LoadingActions.setLoading());
    const {action} = yield select(state => state.usuariosStores);
    if (action === "EDIT") {
      const user = yield call(api.put, `/users/${payload.id}`, payload);

      const {chat_key} = yield select(state => state.permissions);

      if (chat_key) {
        const customer = yield call(
          apiChat.get,
          `/customer?chat_key=${chat_key}`
        );

        const userInsert = {
          name: user.data.name,
          customer: customer.data._id,
          id_in_customer: user.data.id
        };

        yield call(apiChat.put, `/user`, userInsert);
      }
    } else if (action === "SETTINGS") {
      yield call(api.put, `/users/${payload.id}/permissions`, payload);
    }
    yield put(UsuariosActions.getListUsuarios());
    if (action === "EDIT") {
      yield put(ModalActions.close());
    } else if (action === "SETTINGS") {
      yield put(ModalSettingsActions.closeSettings());
    }
    yield put(SuccessActions.openSuccess("Cadastro editado com sucesso."));
    yield put(UsuariosActions.getListUsuariosSelects());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
    yield put(LoadingActions.unsetLoading());
  }
}

export function* addUsuarios({payload}) {
  try {
    yield put(LoadingActions.setLoading());
    const user = yield call(api.post, `/users`, payload);
    yield put(UsuariosActions.searchUsuarios({}));
    yield put(UsuariosActions.getListUsuarios());
    yield put(ModalActions.close());
    yield put(SuccessActions.openSuccess("Cadastro adicionado com sucesso."));
    yield put(UsuariosActions.getListUsuariosSelects());

    const {chat_key} = yield select(state => state.permissions);

    if (chat_key) {
      const customer = yield call(
        apiChat.get,
        `/customer?chat_key=${chat_key}`
      );

      const tenant = yield call(api.get, `/company`);

      const userInsert = {
        name: user.data.name,
        customer: customer.data._id,
        id_in_customer: user.data.id,
        avatar: user.data.avatar,
        email: `${tenant.data.id}${user.data.id}${customer.data.email}`,
        key: customer.data.key,
        password: `${tenant.data.id}${user.data.id}#54578`,
        active: true,
        admin: user.master
      };

      yield call(apiChat.post, `/user`, userInsert);
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* deleteUsuarios() {
  try {
    yield put(LoadingActions.setLoading());
    const {id} = yield select(state => state.usuarios.item);
    yield call(api.delete, `/users/${id}`);
    yield put(UsuariosActions.getListUsuarios());
    yield put(SuccessActions.openSuccess("Cadastro excluído com sucesso."));
    yield put(UsuariosActions.getListUsuariosSelects());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}

export function* searchUsuarios() {
  try {
    yield put(UsuariosActions.getListUsuarios());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* getListUsuariosSelects() {
  try {
    const {data: usuarios} = yield call(api.get, `/users/select`);
    yield put(UsuariosActions.getListUsuariosSuccessSelects(usuarios));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* deleteAllUsuarios({payload}) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.post, `/users/destroy-many`, {
      users_id: payload.selected
    });
    yield put(UsuariosActions.getListUsuarios());
    yield put(SuccessActions.openSuccess("Cadastros excluídos com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}

export function* getUsuarioLocalWorking({payload}) {
  try {
    yield put(LoadingActions.setLoading());
    const {data: user} = yield call(api.get, `/users/${payload.id}/local-working`);

    if (user.birthday) {
      user.birthday = `${moment(user.birthday).format("DD/MM/YYYY")} <span class="italic">(${moment().diff(moment(user.birthday), "years")} anos) </span>`;
    }

    if (user.regions_owner.length > 0 ) {
      user.regions_owner.map(regions => { return [...regions, regions.initial_date = moment(regions.initial_date).format("DD/MM/YYYY") ]; })
    }
    if (user.stores_owner.length > 0 ) {
      user.stores_owner.map(stores => {
        return [
          ...stores,
          stores.initial_date = moment(stores.initial_date).format("DD/MM/YYYY"),
          stores.finish_date = stores.finish_date ? moment(stores.finish_date).format("DD/MM/YYYY") : ""
        ];
      })
    }
    if (user.stores.length > 0 ) {
      user.stores.map(stores => {
        return [
          ...stores,
          stores.initial_date = moment(stores.initial_date).format("DD/MM/YYYY"),
          stores.finish_date = stores.finish_date ? moment(stores.finish_date).format("DD/MM/YYYY") : ""
        ];
      })
    }
    yield put(UsuariosActions.getUsuarioLocalWorkingSuccess(user));
    yield put(ModalLocalWorkingActions.openLocalWorking());

  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* addUsuarioLocalWorking({payload}) {
  try {
    yield put(LoadingActions.setLoading());
    const {data: relation} = yield call(api.post, `/users/${payload.user_id}/local-working`, payload);
    const {item: user } = yield select(state => state.usuarios);
    if (payload.relation === "region_owner") {
      user.regions_owner = relation.map(regions => { return {...regions, initial_date: moment(regions.initial_date).format("DD/MM/YYYY") }; })
    }
    if (payload.relation === "store_owner") {
      user.stores_owner = relation.map(stores => {
        return {
          ...stores,
          initial_date: moment(stores.initial_date).format("DD/MM/YYYY"),
          inish_date: stores.finish_date ? moment(stores.finish_date).format("DD/MM/YYYY") : ""
        };
      });
    }
    if (payload.relation === "store_member") {
      user.stores = relation.map(stores => {
        return {
          ...stores,
          initial_date: moment(stores.initial_date).format("DD/MM/YYYY"),
          finish_date: stores.finish_date ? moment(stores.finish_date).format("DD/MM/YYYY") : ""
        };
      })
    }

    yield put(UsuariosActions.getUsuarioLocalWorkingSuccess(user));
    yield put(LoadingActions.unsetLoading());
    yield put(SuccessActions.openSuccess("Cadastro adicionado com sucesso."));

  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* editUsuarioLocalWorking({payload}) {
  try {
    yield put(LoadingActions.setLoading());
    const {data: relation} = yield call(api.put, `/users/${payload.user_id}/local-working`, payload);
    const {item: user } = yield select(state => state.usuarios);
    if (payload.relation === "region_owner") {
      user.regions_owner = relation.map(regions => { return {...regions, initial_date: moment(regions.initial_date).format("DD/MM/YYYY") }; })
    }
    if (payload.relation === "store_owner") {
      user.stores_owner = relation.map(stores => {
        return {
          ...stores,
          initial_date: moment(stores.initial_date).format("DD/MM/YYYY"),
          inish_date: stores.finish_date ? moment(stores.finish_date).format("DD/MM/YYYY") : ""
        };
      });
    }
    if (payload.relation === "store_member") {
      user.stores = relation.map(stores => {
        return {
          ...stores,
          initial_date: moment(stores.initial_date).format("DD/MM/YYYY"),
          finish_date: stores.finish_date ? moment(stores.finish_date).format("DD/MM/YYYY") : ""
        };
      })
    }

    yield put(UsuariosActions.getUsuarioLocalWorkingSuccess(user));
    yield put(LoadingActions.unsetLoading());
    yield put(SuccessActions.openSuccess("Registro alterado com sucesso."));

  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* deleteUsuarioLocalWorking({payload}) {
  try {
    yield put(LoadingActions.setLoading());
    const {data: response} = yield call(api.put, `/users/${payload.user_id}/local-working/destroy`, payload);
    const {item: user } = yield select(state => state.usuarios);
    if (payload.relation === "region_owner") {
      user.regions_owner = user.regions_owner.filter(regions_owner => regions_owner.relation_id !== response.relation_id);
    }
    if (payload.relation === "store_owner") {
      user.stores_owner = user.stores_owner.filter(stores_owner => stores_owner.relation_id !== response.relation_id);
    }
    if (payload.relation === "store_member") {
      user.stores = user.stores.filter(stores => stores.relation_id !== response.relation_id);
    }
    yield put(UsuariosActions.getUsuarioLocalWorkingSuccess(user));
    yield put(LoadingActions.unsetLoading());
    yield put(SuccessActions.openSuccess("Registro excluído com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/usuarios.js